import React, { useCallback } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { deleteCaregiverConnectionService, deleteCaregiverInvitationService, getConnectionsService, inviteCaregiverService, resendCaregiverInviteService, } from 'Services/libre_api';
const useLibreCaregiver = () => {
    const removeCaregiverConnection = useCallback(async (caregiverConnection) => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        return deleteCaregiverConnectionService(user.id, caregiverConnection.caregiverId, osType, osVersion, app, appVersion);
    }, []);
    const removeCaregiverInvitation = useCallback(async (caregiverInvitation) => {
        const { osType, osVersion, app, appVersion } = store.getState().env;
        const { invitationId } = caregiverInvitation;
        const { user } = store.getState().auth;
        await deleteCaregiverInvitationService(user.id, invitationId, osType, osVersion, app, appVersion);
    }, []);
    const resendCaregiverInvite = useCallback(async (caregiverInvitation) => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        await resendCaregiverInviteService(user.id, caregiverInvitation.invitationId, osType, osVersion, app, appVersion);
    }, []);
    const inviteCaregiver = useCallback(async (firstName, lastName, email) => {
        const { user } = store.getState().auth;
        const { osType, osVersion, app, appVersion } = store.getState().env;
        try {
            const { invitationId } = await inviteCaregiverService(email, firstName, lastName, user.id, osType, osVersion, app, appVersion);
            const { caregiverInvitations } = await getConnectionsService(user.id, osType, osVersion, app, appVersion);
            const caregiverInvitation = caregiverInvitations?.find((caregiverInvitation) => caregiverInvitation.invitationId === invitationId);
            return { caregiverInvitation };
        }
        catch (err) {
            const error = err;
            const errorCode = error.response?.data.code;
            return { errorCode };
        }
    }, []);
    const showRemoveInvitationConfirmationModal = useCallback((onRemoveClick) => {
        store.dispatch({
            type: SHOW_MODAL,
            modalProps: {
                buttonLayout: 'column',
                details: (React.createElement(Stack, null,
                    React.createElement(Text, { color: "$text.100", fontWeight: "$bodyBase.strong", fontSize: "$bodyBase.strong", testID: "RemoveConnectionModal.title", marginBottom: "$4" }, i18n.t('Global.modals.removeConnection.title')),
                    React.createElement(Text, { color: "$text.100", fontWeight: "$bodyBase.default", fontSize: "$bodyBase.default", testID: "RemoveConnectionModal.body" }, i18n.t('Global.modals.removeConnection.body')))),
                primaryAction: {
                    label: i18n.t('Global.microcopy.common.removeCap'),
                    destructive: true,
                    onPress: () => {
                        store.dispatch({
                            type: CLOSE_MODAL,
                        });
                        onRemoveClick();
                    },
                },
                secondaryAction: {
                    label: i18n.t('Global.microcopy.common.cancel'),
                    onPress: () => store.dispatch({
                        type: CLOSE_MODAL,
                    }),
                },
                testID: 'RemoveConnectionModal',
            },
        });
    }, []);
    const showStopSharingModal = useCallback((onRemoveClick) => {
        store.dispatch({
            type: SHOW_MODAL,
            modalProps: {
                buttonLayout: 'column',
                details: (React.createElement(Stack, null,
                    React.createElement(Text, { color: "$text.100", fontWeight: "$bodyBase.strong", fontSize: "$bodyBase.strong", testID: "StopSharingModal.title", marginBottom: "$4" }, i18n.t('Global.modals.stopSharing.title')),
                    React.createElement(Text, { color: "$text.100", fontWeight: "$bodyBase.default", fontSize: "$bodyBase.default", testID: "StopSharingModal.body" }, i18n.t('Global.modals.stopSharing.body')))),
                primaryAction: {
                    label: i18n.t('Global.modals.stopSharing.title'),
                    destructive: true,
                    onPress: () => {
                        store.dispatch({
                            type: CLOSE_MODAL,
                        });
                        onRemoveClick();
                    },
                },
                secondaryAction: {
                    label: i18n.t('Global.microcopy.common.cancel'),
                    onPress: () => store.dispatch({
                        type: CLOSE_MODAL,
                    }),
                },
                testID: 'StopSharingModal',
            },
        });
    }, []);
    return {
        inviteCaregiver,
        resendCaregiverInvite,
        removeCaregiverConnection,
        removeCaregiverInvitation,
        showRemoveInvitationConfirmationModal,
        showStopSharingModal,
    };
};
export default useLibreCaregiver;
